/* eslint-disable @typescript-eslint/no-unused-vars */
import { faFileAlt } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import "../../i18n";
import { TemporalSelectorModes } from "../../layouts/TemporalSelector/TemporalSelector";
import ChartTotalsComponent from "./chartTotals.component";
import DashboardChartWrapper from "./dashboardChartWrapper.component";
import { IstogramData } from "./DashboardComponent";
import DashboarcComponentTitle from "./DashboardComponentTitle";

interface DashboardIstogramDailyDocumentsProps {
	data: IstogramData[];
	mode: TemporalSelectorModes;
	responsiveContainerClassName: string;
}

const DashboardIstogramDailyDocuments: React.FC<DashboardIstogramDailyDocumentsProps> = (props) => {
	const { t } = useTranslation();

	const totals = useMemo(
		() => [
			{
				label: t("dashboard.current"),
				value: props.data.length > 0 ? props.data[0]?.documents ?? 0 : 0,
				color: "#8884d8",
				fontSize: "3.5vw"
			},
			{
				label: t("dashboard.previous"),
				value: props.data.length > 0 ? props.data[1]?.documents ?? 0 : 0,
				color: "#888412"
			}
		],
		[props.data]
	);

	const documents_number_title =
		props.mode === TemporalSelectorModes.week ? t("dashboard.titles.weekly.total_documents_number") : t("dashboard.titles.monthly.total_documents_number");

	return (
		<DashboardChartWrapper>
			<DashboarcComponentTitle title={documents_number_title} />
			<ChartTotalsComponent totals={totals} mainTotal={0} compareTotal={1} deltaSuffix={<FontAwesomeIcon icon={faFileAlt} />} />
			<ResponsiveContainer height={160} className={props.responsiveContainerClassName}>
				<BarChart
					width={500}
					height={300}
					data={props.data ?? []}
					margin={{
						top: 5,
						right: 30,
						left: 20,
						bottom: 5
					}}
				>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey="name" />
					<YAxis />
					<Tooltip />
					<Bar dataKey="documents" name={t("dashboard.dailyDocuments")} fill="#8884d8" />
				</BarChart>
			</ResponsiveContainer>
		</DashboardChartWrapper>
	);
};

export default DashboardIstogramDailyDocuments;
